module.exports = __webpack_public_path__ + "static/media/dice-4.ca61622e.png";